import React from 'react';
import './shared-chrome.css';

/**
 * PageHeader — the ONE way a view introduces itself.
 * Title (one size, one weight), optional one-line blurb, optional
 * right-aligned actions. Views must not build their own hero rows;
 * see docs/TEKSTAK-UX-AUDIT-2026-08.md §5.
 */
export default function PageHeader({ title, blurb, actions }) {
  return (
    <header className="ts-page-header">
      <div>
        <h1 className="ts-page-title">{title}</h1>
        {blurb && <p className="ts-page-blurb">{blurb}</p>}
      </div>
      {actions && <div className="ts-page-actions">{actions}</div>}
    </header>
  );
}
